import React from 'react';
import TableColumnImg from '../../../../../components/table/TableColumnImg';
import TableFilterInput from '../../../../../components/table/TableFilterInput';
import OpenReviewDetail from '../../../../../components/link/OpenReviewDetail';
import OpenBrandDetail from '../../../../../components/link/OpenBrandDetail';
import OpenProductDetail from '../../../../../components/link/OpenProductDetail';
import OpenPreviewProductDetail from '../../../../../containers/app/common/OpenPreviewProductDetail';
import Anchor from '../../../../../components/link/Anchor';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import { asyncSimpleModal } from '../../../../../lib/common';
import { setDateFormat } from '../../../../../lib/moment';

/**
 *  선택된 상품 후기 아이템 리스트와 상품 후기 리스트의 공통 컬럼
 */
export const columns = (data) => {
  const sortable = !!Object.keys(data).length;
  const { filterOption, onFilter } = data;

  return [
    {
      id: 'url',
      Header: '이미지',
      accessor: 'url',
      width: 100,
      Cell: (row) => <TableColumnImg url={row.value} width={'60px'} height={'60px'} />,
    },
    {
      id: 'rate',
      Header: '별점',
      accessor: 'rate',
      width: 100,
      sortable,
      minWidth: 120,
    },
    {
      id: 'id',
      Header: '상품 후기 ID',
      accessor: 'id',
      filterable: !!filterOption,
      Cell: (row) => <OpenReviewDetail text={row.value} reviewId={row.value} />,
      Filter: () => <TableFilterInput option={filterOption.reviewId} onFilter={(reviewId) => onFilter({ reviewId })} />,
    },
    {
      id: 'content',
      Header: '상품 후기 내용',
      accessor: 'content',
      filterable: !!filterOption,
      Cell: (row) => (
        <Anchor
          text="내용 보기"
          isUnderLine
          color="primary"
          onClick={async () =>
            await asyncSimpleModal({
              type: 'info',
              title: '상품 후기 내용',
              message: row.value,
            })
          }
        />
      ),
      Filter: () => <TableFilterInput option={filterOption.content} onFilter={(content) => onFilter({ content })} />,
    },
    {
      id: 'storeId',
      Header: '브랜드 ID',
      accessor: 'storeId',
      filterable: !!filterOption,
      Cell: (row) => <OpenBrandDetail text={row.value} storeId={row.value} />,
      Filter: () => <TableFilterInput option={filterOption.storeId} onFilter={(storeId) => onFilter({ storeId })} />,
    },
    {
      id: 'storeName',
      Header: '브랜드명',
      accessor: 'storeName',
      filterable: !!filterOption,
      Cell: (row) => <OpenBrandDetail text={row.value} storeId={row.original.storeId} />,
      Filter: () => (
        <TableFilterInput option={filterOption.storeName} onFilter={(storeName) => onFilter({ storeName })} />
      ),
    },
    {
      id: 'productId',
      Header: '상품 ID',
      accessor: 'productId',
      filterable: !!filterOption,
      Cell: (row) => <OpenProductDetail text={row.value} productId={row.value} />,
      Filter: () => (
        <TableFilterInput option={filterOption.productId} onFilter={(productId) => onFilter({ productId })} />
      ),
    },
    {
      accessor: 'productName',
      Header: '상품명',
      filterable: !!filterOption,
      minWidth: 200,
      Cell: (row) => <OpenPreviewProductDetail text={row.value} productId={row.original.productId} />,
      Filter: () => (
        <TableFilterInput option={filterOption.productName} onFilter={(productName) => onFilter({ productName })} />
      ),
    },
    {
      accessor: 'createDate',
      Header: '작성 일자',
      sortable,
      minWidth: 120,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_DASH_FORMAT),
    },
  ];
};

export default columns;
